import { animate, state, style, transition, trigger } from '@angular/animations';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ShiveAnimationsService {
  // Used for the animation of sorting controls (e.g. invoice).
  public static fadeAnimation = trigger('fadeAnimation', [
    // State-based transitions (for your hover “visible” / “hidden” states)
    state('hidden', style({ opacity: 0 })),
    state('visible', style({ opacity: 1 })),

    // When you explicitly flip between “hidden” ↔ “visible”
    transition('hidden => visible', animate('{{ duration }} cubic-bezier(.4,0,.2,1)'), {
      params: { duration: '100ms' },
    }),
    transition('visible => hidden', animate('{{ duration }} cubic-bezier(.4,0,.2,1)'), {
      params: { duration: '100ms' },
    }),

    // Handle the element actually entering / leaving the DOM
    transition(
      ':enter',
      [
        style({ opacity: 0 }),
        animate('{{ duration }} cubic-bezier(.4,0,.2,1)', style({ opacity: 1 })),
      ],
      { params: { duration: '100ms' } },
    ),
    transition(
      ':leave',
      [
        style({ opacity: 1 }),
        animate('{{ duration }} cubic-bezier(.4,0,.2,1)', style({ opacity: 0 })),
      ],
      { params: { duration: '100ms' } },
    ),
  ]);

  public static fadeOnHoverAnimation = [
    trigger('fadeOnHover', [
      state('hidden', style({ opacity: 0 })),
      state('visible', style({ opacity: 1 })),
      transition('hidden <=> visible', animate('100ms cubic-bezier(.4,0,.2,1)')),
    ]),
  ];

  private readonly running = new WeakMap<HTMLElement, Animation>();

  public triggerSortableRowsNew(
    sortableRow: HTMLElement,
    diff: number,
    animationDuration: number,
    reset?: boolean,
  ): Animation {
    // Cancel previous animation for this element (prevents stacking)
    this.running.get(sortableRow)?.cancel();

    // Compute current transform (so we can animate from "where it is now")
    const computed = getComputedStyle(sortableRow).transform;
    const from = computed === 'none' ? 'translateY(0px)' : computed;

    diff = reset ? 0 : diff;
    const to = `translateY(${diff}px)`;

    const animation = sortableRow.animate([{ transform: from }, { transform: to }], {
      duration: animationDuration,
      easing: 'cubic-bezier(0, 0, 0.2, 1)',
      fill: 'forwards',
    });

    animation.onfinish = () => {
      sortableRow.style.transform = to;
      if (reset) {
        sortableRow.style.transform = '';
      }
      this.running.delete(sortableRow);
    };

    animation.oncancel = () => {
      this.running.delete(sortableRow);
    };

    this.running.set(sortableRow, animation);
    return animation;
  }
}
